import request from '@/utils/request';

/**
 * 拉取当前用户接收到的全部待处理好友申请记录列表
 * @returns {Promise}
 */
export function getMyApplyList() {
  return request({
    url: '/api/friend-apply/list',
    method: 'get'
  });
}

export function getMyApplyPage(pageNum, pageSize) {
  return request({
    url: '/api/friend-apply/page',
    method: 'get',
    params: { pageNum, pageSize }
  });
}

/**
 * 确认并通过指定ID的好友申请请求
 * @param {String|Number} applyId 申请记录表主键ID
 * @returns {Promise}
 */
export function acceptFriendApply(applyId) {
  return request({
    url: '/api/friend-apply/accept',
    method: 'post',
    data: { applyId }
  });
}

/**
 * 向目标用户发起单向好友/客服添加申请请求
 */
export function submitFriendApply(friendId, verifyMsg) {
  return request({
    url: '/api/friend-apply/submit',
    method: 'post',
    data: { friendId, verifyMsg }
  });
}

/**
 * 动态拉取当前用户接收到的待处理好友申请总数量（红点计数）
 * @returns {Promise}
 */
export function getUnprocessedApplyCount() {
  return request({
    url: '/api/friend-apply/count',
    method: 'get'
  });
}